import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// tone="light" for panels on light sections, tone="dark" for panels on the dark hero/luxury bands.
const GlassPanel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tone',
})(({ tone = 'light' }) => ({
  position: 'relative',
  borderRadius: 20,
  backdropFilter: 'blur(18px)',
  WebkitBackdropFilter: 'blur(18px)',
  border: tone === 'dark' ? '1px solid rgba(255,255,255,0.14)' : '1px solid rgba(255,255,255,0.6)',
  background: tone === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.65)',
  boxShadow:
    tone === 'dark' ? '0 8px 32px rgba(0,0,0,0.35)' : '0 8px 32px rgba(20,20,40,0.08)',
}));

export default GlassPanel;
